/*
 * @Author: swmonk
 * @Date: 2020-11-25 16:08:35
 * @LastEditTime: 2020-11-25 16:14:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ufun-new-bc/src/store/slice/systemInfo.js
 */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    "sysUser": {
        "id": 0,
        "roleId": 0,
        "businessType": "",
        "businessLevel": "",
        "deptId": 0,
        "avatar": null,
        "userName": "",
        "userPassword": null,
        "userRealName": "",
        "userPhone": "",
        "state": "",
        "remark": null,
        "lastLoginTime": "",
        "creator": "",
        "modifier": "",
        "createTime": "",
        "modifyTime": "",
        "isDeleted": 0
      },
      "sysRole": {
        "id": 0,
        "businessType": "",
        "businessLevel": "",
        "state": "",
        "remark": null,
        "creator": "",
        "modifier": "",
        "createTime": "",
        "modifyTime": "",
        "isDeleted": 0
      },
      "pathList": [
        "/"
      ]
}

export default createSlice({
    name: 'sysuserInfo',
    initialState,
    reducers: {
        save: (state,action) => action.payload,
        clear: () => initialState,
    },
})
